import PropTypes from "prop-types"
import React, { PureComponent } from "react"
import classnames from "classnames"
import * as R from "ramda"

import Translate from "../../../../app/scripts/components/Translate"

const omittedProps = [
  "options",
  "initialValue",
  "autofill",
  "onUpdate",
  "valid",
  "invalid",
  "dirty",
  "pristine",
  "error",
  "active",
  "touched",
  "visited",
  "autofilled",
]

export default class NewSelectField extends PureComponent {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    // optional
    label: PropTypes.node,
    error: PropTypes.string,
    touched: PropTypes.bool,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    disabled: false,
  }

  // render
  // ===
  renderError(error: string) {
    return (
      <div className="spField-error">
        <Translate tKey={error} className="spField-note spTypo-note" />
      </div>
    )
  }

  renderLabel(label, required) {
    return (
      <div className="spField-label">
        {label}
        {required ? "*" : ""}
      </div>
    )
  }

  render() {
    const {
      value,
      error,
      label,
      touched,
      onChange,
      options,
      required,
      placeholder,
      disabled,
    } = this.props

    const classes = classnames("NewSelectField", "spField", {
      _error: error && touched,
      _ok: !error && touched,
      _hasLabel: label,
      _notSelected: !value,
      _twoLines: label,
      _oneLine: !label,
      _disabled: disabled,
    })

    return (
      <div className={classes}>
        <label>
          {this.renderLabel(label, required)}
          {error && touched && this.renderError(error)}

          <div className="spField-input">
            <select
              {...R.omit(omittedProps, this.props)}
              value={value || ""}
              onChange={ev => onChange(ev.target.value)}
              disabled={disabled}
            >
              {placeholder && (
                <option value="" disabled>
                  {placeholder}
                </option>
              )}
              {options.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </label>
      </div>
    )
  }
}
